import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getSBSItineraryData } from '../SBSHelpers/SBSHelpers'
import { checkIfSinglePassenger } from '../../ListingsContent/helpers'
import { logChangeFlight } from '@mfs/client/common/log-ga-event/logGaEvent-internal-link'
import { flySliceSelectionStorage } from '../../Legacy/fly-slice-selection-storage/fly-slice-selection-storage'
import { loadSavedFilterInfo, setTabDefaultFilters } from '@mfs/client/listings-client/actions/listings'
import { setOverfilteredStatus } from '@mfs/client/listings-client/reducers/flags'
import { updateActiveTabId } from '@mfs/client/listings-client/reducers/listings'
import { resetTimeFilters } from '@mfs/client/listings-client/actions'
import { updateAirlineFiltersUI } from '@mfs/client/listings-client/reducers/filters/airlinesFilter/airlinesFilter'
import { updateAirlineFiltersReq } from '@mfs/client/listings-client/reducers/filters/filterInfo/filterInfo'

export const useDepartureSummary = ({ selectedDepartureSummaries = [], setSelectedDepartureSummaries }) => {
  const [departureSummaryData, setDepartureSummaryData] = useState([])
  const dispatch = useDispatch()
  const activeTabId = useSelector((state) => state?.activeTabId)
  const isShelves = useSelector((state) => state?.pclnBootstrapData?.isShelves)
  const searchRequest = useSelector((state) => state.pclnBootstrapData?.searchRequest)
  const airSearchRequestModel = useSelector((state) => state.airSearchRequestModel)
  const isSinglePassenger = checkIfSinglePassenger(searchRequest.params)

  /**
   * SBS
   * For RT: This works only onClick of Departure Tab,
   * remove the sliceKey from SliceFilters so that it doesn't clash with other slice filter params
   * */
  const handleTabChange = ({ id }) => {
    const prevTabId = activeTabId
    logChangeFlight(searchRequest.tripType)

    if (id === 1) {
      dispatch(setOverfilteredStatus(false))
    }
    flySliceSelectionStorage.removeAboveTabId(id)
    airSearchRequestModel.setSliceRefId({ sliceRefId: [id] })

    setSelectedDepartureSummaries(selectedDepartureSummaries.slice(0, id - 1))
    dispatch(setTabDefaultFilters({ tabId: prevTabId }))
    dispatch(
      resetTimeFilters({
        entity: 'takeoff',
      })
    )
    dispatch(
      resetTimeFilters({
        entity: 'landing',
      })
    )

    dispatch(updateAirlineFiltersUI({ payload: {}, meta: { isNoneClick: true } }))
    dispatch(
      updateAirlineFiltersReq({
        payload: {},
        meta: { isNoneClick: true },
        airlines: [],
        sbsParams: {
          activeTabId,
        },
      })
    )
    dispatch(updateActiveTabId(id))
    dispatch(loadSavedFilterInfo({ tabId: id }))
  }

  useEffect(() => {
    if (activeTabId > 1) {
      const departureSummaryData = selectedDepartureSummaries?.map((selectedDepartureSummary) =>
        getSBSItineraryData({
          itinerary: selectedDepartureSummary,
          isDepartureSummary: true,
          isUserLoggedIn: null,
          activeTabId: activeTabId,
          departureSummaryData: null,
          tripType: null,
          isSinglePassenger,
          isShelves,
        })
      )

      setDepartureSummaryData(departureSummaryData)
    }
  }, [activeTabId, isShelves, isSinglePassenger, selectedDepartureSummaries])

  return { departureSummaryData, handleTabChange }
}
